import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  container: {
    // marginLeft: '2rem',
    // marginRight: '2rem',
    // paddingTop: '1rem',
  },
  actionsContainer: {
    justifyContent: "space-between",
    flexDirection: "row",
  },
  buttonContainer: {
    flexDirection: "row",
    textTransform: "uppercase",
    alignItems: "center",
    cursor: "pointer",
  },
  description: {
    fontWeight: 400,
    justifyContent: "center",
    marginBottom: 10,
  },
});

export default useStyles;
